'use strict';
let languageOption = {
    fr_FR: 'fra',
    en_IM: 'eng',
    en_US: 'enu'
}
/**
 * Function to add the shade finder product.
 * @param {string} skuId - product ID adding to the cart 
 */
function addYmkProductToCart(skuId) {
    var addToCartUrl = $('.add-to-cart-vto-url').val() || $('.add-to-cart-url').val();

    if (!addToCartUrl || !skuId) {
        return;
    }

    $('body').trigger('product:beforeAddToCart');
    var form = {
        pid: skuId,
        quantity: 1
    };

    $.ajax({
        url: addToCartUrl,
        method: 'POST',
        data: form,
        success: function (data) {
            $('.minicart').trigger('count:update', data);
            $('body').trigger('product:afterAddToCart', data);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

$(document).on("sfvto:init", function() {
    var shadefinderADAbutton = $('#shadefinder-ADA-button').val();
    $("#vto-sf-modal").animate({ scrollTop: 150 }, 1000);
    let masterProductId = $('button.js-button-sf').attr('data-masterproductid') ? $('button.js-button-sf').attr('data-masterproductid') : '';
    let language = languageOption[$('button.js-button-sf').attr('data-locale')];
    var initParameters = {
        shadeFinderVersion: 'v4',
        disable2ColorComparison: true,
        hideAllButtonsOnResult: true,
        shadeFinderDeltaEThreshold: '3',
        skinSmoothStrength: 33,
        language: language,
        shadeFinderResultVersion: 'v2',
        showShadeFinderLogo: false,
        showBackAndCloseButton: true,
        userConsent: 'agree',
        priorityProducts: [masterProductId]
    };
    // Device type tablets Ipad Pro Ipad mini
    var windowSize = $(window).width();
    var windowHeight = $(window).height();
    if (windowSize < 500) {
        initParameters.width = windowSize;
        initParameters.height = windowHeight;
    } else if (windowSize > 500 && windowSize < 992){
        initParameters.width = 544;
        initParameters.height = 619;
    } else {
        initParameters.width = 464;
        initParameters.height = 700;
    }
    // Init SF module
    window.YMK.init(initParameters);
    // Open SF module
    window.YMK.openShadeFinder();
    $('body').addClass('lock-body');

    if ($(window).width() < 500) {
        $('.modal-backdrop').addClass('d-none');
    }

    window.YMK.addEventListener('backToLive', function () {
        $('.custom-shade-search').show();
    });
  
    window.YMK.addEventListener('enterTakePhoto', function () {
        $('.custom-shade-search').hide();
    }); 

    window.YMK.addEventListener("closed", function() {
        $('#one-to-one-initiation').removeClass('d-none');
        $(".retry-vto-sf").removeClass("hidden");
        $('.sf-optin-logo').hide();
        $('.close-shade').hide();
        $("#vto-sf-modal .close").trigger("click");
        $('.custom-shade-search').hide();
        $('body').removeClass('lock-body');
        if ($(window).width() < 500) {
            $('.modal-backdrop').addClass('d-none');
        }
    });

    window.YMK.addEventListener('opened', function () {
        $.spinner().stop();
        $('.sf-optin-logo').show();
        $('.close-shade').show();
    });

    window.YMK.addEventListener("addToCart", function (e) {
        var skuId = e;
        $('#mini-cart-modal').addClass('sf-mini-cart');

        addYmkProductToCart(skuId);
    });

    $("#vto-sf-modal .close-shade").on('click', function () {
        window.YMK.closeEngine();
        $('.custom-shade-search').hide();
        $('#vto-sf-modal').modal('hide');
        $('.YMK-centent').removeClass('hide');
        $('.suggestions-shade-details').removeClass('show');
        $('body').removeClass('lock-body');
    })

    /**
     * Fill all elements regarding shade information
     * @param {*} shadeData 
     * @param {*} shadeNameElt 
     * @param {*} clickShadeElt 
     * @param {*} squareShadeElt 
     */
    function applyShade(shadeData, shadeNameElt, clickShadeElt, squareShadeElt) {
        if (shadeData) {
            $(clickShadeElt)
                .attr('data-value', shadeData.id)
                .attr('data-attr-value', shadeData.shadeID)
                .attr('aria-label', shadefinderADAbutton + ' ' + shadeData.shadeName)
                .attr('data-shade-oos',shadeData.shadeOOS);
            $(shadeNameElt).text(shadeData.shadeName);
            $(squareShadeElt).attr('fill', shadeData.colorCode);
            if (shadeData.shadeOOS) {
                $(clickShadeElt).append('<span class="strock-line"></span>');
            }
        }
       
    }

    /**
     * Event launched by Perfect Corp once the shade finder is completely loaded
     */
    window.YMK.addEventListener('shadeFinderComplete', function (data) {
        var matchedProductIds = [];
        var productIds = [];
        // Get recommendations from Perfect Corp
        var recommendations = data.recommendations;
        var productListIds = JSON.parse($('#product-list-ids').html());
        // Check each PC recommandations
        for (var i = 0; i < recommendations.length; i++) {
            // Check if product recommended exists on SFCC
            if (recommendations[i].matched && productListIds) {
                for (var j = 0; j < productListIds.length; j++) {
                    if (recommendations[i].matched.skuId === productListIds[j].id) {
                        matchedProductIds.push(productListIds[j]);
                        productIds.push(productListIds[j].id);
                    }
                }
            }
        }
        window.YMK.enableCompare();
        var nbShade = 3;
        // Best shade
        applyShade(matchedProductIds[0], '.skintone-shadename2', '.skintone-click2', '.square2 circle');
        $('.skintone-click2').trigger('click').addClass('click-first-button');
        // Hide shade if necessary
        if(!matchedProductIds[1]) {
            $('.skintone-circle-1').hide();
            nbShade--;
        } else {
            applyShade(matchedProductIds[1], '.skintone-shadename1', '.skintone-click1', '.square1 circle');
        }

        if (!matchedProductIds[2]) {
            $('.skintone-circle-3').hide();
            nbShade--;
        } else {
            applyShade(matchedProductIds[2], '.skintone-shadename3', '.skintone-click3', '.square3 circle');
        }

        $('.skintone-wrapper').show();
        $('.matching-wrapper').show();

        var dataUrl = $(".gtmurl").attr("data-url") + '?products=' + productIds.slice(0, nbShade);

        $.ajax({
            url: dataUrl,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                dataLayer.push(data.productListGtm);
                if (data.productListGtm.ecommerce.impressions[0]) {
                    var productName = data.productListGtm.ecommerce.impressions[0].name;
                    var vtoSite = $(".gtmsite").attr("data-site");

                    dataLayer.push({
                        'event': 'shade_finder_result',
                        'sf_product_name': productName,
                        'sf_site_name': vtoSite,
                    });
                }
            },
            error: function () {
            }
        });
    });
});

var minChars = 3;

function getSuggestionsShadeWrapper() {
    return $('.suggestions-shade-details');
}

function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}

function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile span.';
    var iconSearch = 'icon-SEARCH';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose);
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch);
    }
}

function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

function processResponseShade(response) {
    var $suggestionsWrapper = getSuggestionsShadeWrapper(this).empty();
    if (!(typeof (response) === 'object')) {
        $suggestionsWrapper.append(response).fadeIn();
        positionSuggestions(this);
        if (isMobileSearch(this)) {
            toggleSuggestionsIcon('close');
        }
        $('#no-result-search').text($('.search-field').val());
        $('body').trigger('LoadSliderImages');
    } else {
        $suggestionsWrapper.fadeOut();
    }
    $('.custom-shade-search').show();
    $('#YMK-wrapper').focus();
}

function getSuggestionsShadeProduct(scope) {
    if ($(scope).attr('data-value').length >= minChars) {
        $.ajax({
            context: scope,
            url: $(scope).attr('data-url') + $(scope).attr('data-value'),
            method: 'GET',
            success: processResponseShade,
            error: function () {
            }
        });
        $('.product-view-suggestion').removeClass('col-md-4').addClass('col-md-12');
    } else {
        toggleSuggestionsIcon('search');
        getSuggestionsShadeWrapper(scope).empty();
    }
}

$(document).on('click', '.skintone-click1, .skintone-click2, .skintone-click3', function (event, a, b) {
    $(this).parents('.skintone-item').addClass('active').siblings('.skintone-item').removeClass('active');
    if($('.skintone-click2').hasClass('click-first-button')){
        var datalayername = $(this).siblings('.datalayer-name').text();
        var productName = $(".js_product-name").attr("data-product");
        var vtoSite = $(".gtmsite").attr("data-site");
        if (productName && vtoSite) {
            dataLayer.push({
                'sf_type': 'Shade',
                'sf_name': datalayername.toString().replace(/[^a-z0-9\s]/gi, '').trim(),
                'sf_product_name': productName,
                'sf_site_name': vtoSite,
                'event':'shade_finder_click'
            });
        }
    }
    $('.shadefinder-shadesquare').removeClass('active');
    $(this).find('svg').addClass('active');
    $("#vto-sf-modal").animate({ scrollTop: 150 }, 1000);
    getSuggestionsShadeProduct($(this), b);
    var shadeOOSValue = $(this).attr('data-shade-oos');
    var ariaLabelValue = $('input[name="ariaLabelShade"]').val().trim();
    var addToCart2Value = $('input[name="addToCart2"]').val().trim();
    var outOfStockValue = $('input[name="outOfStock"]').val().trim();
    if (shadeOOSValue === 'true') {
        $('a.productLinktoShade-desktop').replaceWith('<a href="javascript:void(0)" aria-label="' + ariaLabelValue + '" class="btn btn-primary productLinktoShade-desktop disabled">' + outOfStockValue + '</a>');
    } else {
        $('a.productLinktoShade-desktop').replaceWith('<a href="javascript:void(0)" aria-label="' + ariaLabelValue + '" class="add-cart productLinkto productLinktoShade-desktop">' + addToCart2Value + '</a>');
    }
    window.YMK.applyMakeupBySku($(this).attr('data-value'));
});

$('button.shade-circle-wrapper').each(function () {
    $(this).attr(
        'tabindex',
        $(this).hasClass('skintone-click2') ? '0' : '-1'
    );
    $(this).attr('role', 'radio');
});

$('button.shade-circle-wrapper').on('keydown', function (event) {
    var $skintoneCircle = $(this).closest('.skintone-circle');
    var $buttons = $skintoneCircle.find('.shade-circle-wrapper');
    var currentIndex = $buttons.index(this);
    var nextIndex, prevIndex;

    if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % $buttons.length;
        $buttons.eq(nextIndex).attr('tabindex', '0').focus().click();
        $(this).attr('tabindex', '-1');
    } else if (event.key === 'ArrowLeft') {
        prevIndex =
            (currentIndex - 1 + $buttons.length) % $buttons.length;
        $buttons.eq(prevIndex).attr('tabindex', '0').focus().click();
        $(this).attr('tabindex', '-1');
    }
});

$(document).on('click', '#aquaresist-wrapper .shadefinder-shadesquare, #mascarapro-wrapper .shadefinder-shadesquare', function (event, a, b) {
    if(!($(this).hasClass('disabledshade'))){
        if($('.landing-rouge-shade-interact-module-shade-svg:first-child').hasClass('click-first-button')){
            var datalayername = $(this).attr('aria-label');
            dataLayer.push({
                'sf_type': 'Shade',
                'sf_name': datalayername,
                'event':'red_shade_click'
            });
        }else{
            $('.landing-rouge-shade-interact-module-shade-svg:first-child').addClass('click-first-button');
        }
        $('#aquaresist-wrapper .shadefinder-shadesquare, #mascarapro-wrapper .shadefinder-shadesquare').removeClass('active');
        $(this).addClass('active');
        getSuggestionsShadeProduct($(this), b);
        window.YMK.reset()
        window.YMK.applyMakeupBySku($(this).attr('data-id'));
        $('.shade-name-tile').css('color', $(this).attr('fill'));
    }
});

$(document).on('keypress', '.landing-rouge-shade-interact-module-shade-svg path', function(e){
    if(e.which == 13) {
        $(this).trigger('click');
    }
});

$(document).on('click', '.retry-vto-sf', function() {
    if (!window.YMK.isLoaded()) {
        window.YMK.openShadeFinder();
    }
    $(".retry-vto-sf").addClass("hidden");
});

$('.sr-only-focus a').click(function(e){
    e.preventDefault();
    var linktofocus = $(this).attr('href');
    if($(this).hasClass('skip-color-picker')){
        $(linktofocus).focus();
    } else {
        $(linktofocus).find('path:first-child').focus();
    }
});
